import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle } from 'recompose';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography/Typography';
import { withStyles } from '@material-ui/core/styles';

import {
  saveVersionRequest,
  overwriteVersionRequest,
  resetSaveEditForm,
} from '../../redux/reducers/savedVersions';
import { toggleSaveEditPopup, toggleNotification } from '../../redux/reducers/view';

import VersionNameField from './VersionNameField';
import { validateSaveEditPassword } from './validate';

import { commonStyles } from '../../styles/styles';

const SaveEditForm = ({
  classes,
  handleSubmit,
  submitting,
  handleSaveEdit,
  savedVersions,
  userProgramsFull,
  handleOverwrite,
}) => (
  <form onSubmit={handleSubmit(handleSaveEdit)} className={classes.formPopup}>
    {savedVersions.error && (
      <Typography className={classes.formError}>{savedVersions.error.message}</Typography>
    )}
    <Field name="versionName" component={VersionNameField} />
    <div className={classes.buttonHolder}>
      <Button
        variant="contained"
        className={`${classes.defaultButton} ${classes.button}`}
        disabled={submitting}
        type="submit"
      >
        save
      </Button>
      {userProgramsFull.selectedUserVersion !== null && (
        <Button
          variant="contained"
          className={`${classes.transparentButton} ${classes.button}`}
          disabled={submitting}
          onClick={() => handleOverwrite()}
        >
          overwrite
        </Button>
      )}
    </div>
  </form>
);

const mapStateToProps = state => ({
  formState: state.form,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
});
const mapDispatchToProps = dispatch => ({
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  resetSaveEditForm: () => dispatch(resetSaveEditForm()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toggleNotification: value => dispatch(toggleNotification(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
});

const styles = () => ({
  ...commonStyles,
  button: {
    width: 100,
    margin: '10px 0',
  },
  buttonHolder: {
    display: 'flex',
    width: 260,
    justifyContent: 'space-around',
  },
});

export default compose(
  reduxForm({
    form: 'saveEdit',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleSaveEdit: props => values => {
      validateSaveEditPassword(values);
      props.saveVersionRequest();
    },
    handleOverwrite: props => () => {
      props.overwriteVersionRequest();
    },
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const {
        toggleNotification,
        toggleSaveEditPopup,
        savedVersions,
        saveVersionRequest,
      } = nextProps;

      if (savedVersions.isVersionSaved) {
        toggleNotification({
          value: true,
          message: 'Version was saved successfully',
          type: 'success',
        });
        toggleSaveEditPopup(false);
        //saveVersionRequest();
      }
      if (savedVersions.isOverwriteVersion) {
        toggleNotification({
          value: true,
          message: 'Version was overwritten successfully',
          type: 'success',
        });
        toggleSaveEditPopup(false);
        //saveVersionRequest();
      }
    },
  }),
  withStyles(styles),
)(SaveEditForm);

SaveEditForm.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  handleSaveEdit: PropTypes.func,
  savedVersions: PropTypes.instanceOf(Object),
  userProgramsFull: PropTypes.instanceOf(Object),
  handleOverwrite: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Components/Form/SaveEditForm.jsx